<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <img
            :src="`/img/repair/${categoryInfo.slug}/${serviceInfo.slug}.jpg`"
            :alt="serviceInfo[`description_${$i18n.locale}`]"
            :title="serviceInfo[`description_${$i18n.locale}`]"
            :data-fallback="`https://placehold.co/600?text=${
              serviceInfo[`description_${$i18n.locale}`]
            }`"
          />
          <!-- onerror="this.onerror=null;this.src=this.getAttribute('data-fallback')" -->
        </div>
        <div class="col-md-6">
          <ol>
            <li v-for="(item, index) in list" :key="slug + index">
              <router-link tag="a" :to="getPath(getSubPath(item))">
                {{ item.subcategory }}
                {{ item.price ? getPrice(item) : emptyPrice }}
              </router-link>
            </li>
          </ol>
        </div>
      </div>
      <div class="row mt-20">
        <div class="container">
          <div class="col-md-12">
            <div v-html="serviceInfo[`content_${$i18n.locale}`]"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RepairPageMixin from '@/components/repair/RepairPageMixin'

export default {
  name: 'RepairServiceService',
  mixins: [RepairPageMixin],
  computed: {
    list() {
      return this.services.filter(
        ({ slug, category }) =>
          slug === this.serviceInfo.slug && category === this.categoryInfo?.name
      )
    },
  },
  methods: {
    getSubPath(item) {
      const cat = this.categories.find(({ name }) => name === item.category)
      if (cat) {
        const sub = cat.subData.find(({ name }) => name === item.subcategory)
        return `${cat?.slug}/${sub?.slug}/${item.slug}`
      }
      return ''
    },
  },
}
</script>

<style>
</style>
